<template>
  <div class="relative">
    <slot />

    <template v-if="!disableModals">
      <ItemModal
        v-if="showItemModal"
        :item="showItem"
        @close="showItemModal = false"
      />
      <AddedFlashProductToCartModal
        v-if="showBoughtModal"
        :item="boughtItem"
        @close="showBoughtModal = false"
      />
      <FailedToAddFlashProductToCartModal
        v-if="showFailedBoughtModal"
        :errors="boughtErrors"
        @close="showFailedBoughtModal = false"
      />
    </template>

    <a
      v-if="backToTop"
      href="javascript:void(0);"
      class="fixed z-40 right-4 bottom-4 text-center bg-sky-500 rounded py-2 sm:py-3 px-3 sm:px-4 border border-white"
      @click="scrollBackToTop"
    >
      <i class="fal fa-chevron-up text-white text-lg" />
    </a>
  </div>
</template>

<script>
import AddedFlashProductToCartModal from '../Modals/AddedFlashProductToCartModal';
import FailedToAddFlashProductToCartModal from '../Modals/FailedToAddFlashProductToCartModal';
import ActionHandlers from '../Mixins/ActionHandlers';
import BackToTop from '../Mixins/BackToTop';
import ItemModal from '../Modals/ItemModal';

export default {
  components: {
    ItemModal,
    AddedFlashProductToCartModal,
    FailedToAddFlashProductToCartModal,
  },

  mixins: [ActionHandlers, BackToTop],

  props: {
    disableModals: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
